
import React from 'react';
import { useBreakpoint } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { ArrowRight, Zap, Timer } from 'lucide-react';
import CTAButton from '@/components/CTAButton';

const FinalCTASection = () => {
  const {
    isMobile
  } = useBreakpoint();
  return <section className="py-20 md:py-32 bg-gradient-to-br from-[#003a70] via-[#003a70]/95 to-[#003a70]/90 relative overflow-hidden">
      {/* Enhanced background decorations */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/4 left-1/6 w-96 h-96 bg-[#FEE6D8]/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 right-1/6 w-80 h-80 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute top-2/3 left-1/2 w-64 h-64 bg-gradient-to-r from-[#FEE6D8]/30 to-white/20 rounded-full blur-2xl"></div>
      </div>

      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="text-center space-y-8">
          
          {/* Urgency Indicator */}
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-[#FEE6D8] rounded-full shadow-xl">
            <Timer className="text-[#003a70]" size={24} />
            <span className="text-[#003a70] font-bold text-lg">Final Call</span>
          </div>

          {/* Bold CTA Headline */}
          <h2 className={cn("font-black text-white leading-tight tracking-tight", isMobile ? "text-4xl" : "text-5xl lg:text-6xl")}>
            GET THE GENIUS CARD
            <br />
            <span className="text-[#FEE6D8]">PLAYBOOK NOW</span>
          </h2>

          {/* Main Copy */}
          <div className="space-y-6 max-w-3xl mx-auto">
            <p className={cn("text-white/90 leading-relaxed font-medium", isMobile ? "text-lg" : "text-xl")}>
              Don't let another networking opportunity slip by. While other consultants are still struggling with cold emails and uncomfortable sales conversations, you could be the one with the innovative solution that makes prospects come to you.
            </p>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Zap className="text-[#FEE6D8]" size={32} />
              </div>
              <p className={cn("text-white font-semibold leading-relaxed", isMobile ? "text-xl" : "text-2xl")}>
                The AI revolution is happening <span className="text-[#FEE6D8]">now</span>. Your prospects are <span className="text-[#FEE6D8]">ready</span>.
              </p>
            </div>

            <p className={cn("text-white/80 font-medium italic", isMobile ? "text-lg" : "text-xl")}>
              The question is: <span className="text-[#FEE6D8] font-bold not-italic">Are you?</span>
            </p>
          </div>

          {/* CTA Button */}
          <div className="pt-8">
            <CTAButton variant="accent" to="https://cart.deliciousmarketing.io/genius-card-playbook/?coupon=GENIUS-LAUNCH" className={cn("text-[#003a70] font-bold shadow-2xl hover:shadow-xl transition-all duration-300 border-2 border-[#FEE6D8]/50", isMobile ? "text-lg py-4 px-8" : "text-xl py-6 px-12")}>
              <span className={cn("flex items-center gap-3", isMobile ? "text-lg flex-col sm:flex-row" : "text-4xl")}>
                {isMobile ? "Get Playbook Now" : "Get Your Genius Card Playbook"}
                <ArrowRight size={isMobile ? 20 : 24} />
              </span>
            </CTAButton>
          </div>

          {/* Bottom reinforcement */}
          <div className="pt-6">
            <p className="text-white/60 text-sm md:text-base">
              Join the consultants who are already closing deals with AI-powered business cards
            </p>
          </div>

        </div>
      </div>
    </section>;
};

export default FinalCTASection;
